function addSceneEvents(scene) {
  /*document.body.addEventListener('click', (event) => {

  });

  window.addEventListener('resize', resizeHandler);

  function resizeHandler() {
    scene.positionScene();
  }*/
}

export default addSceneEvents;
